import type { JSX } from 'react';
import { Alert, Typography } from '@mui/material';

export function NotFoundPage(): JSX.Element {
  return (
    <>
      <Typography variant="h1" gutterBottom>
        Página não encontrada
      </Typography>
      <Alert severity="info">
        Esta rota não existe no painel. Use a navegação lateral para voltar a uma área existente.
      </Alert>
    </>
  );
}